import Api from '../utils/api.service';
import ApiUrlConstant from '../utils/apiUrl.constant';
import Util from '../utils/util';
export default class CartService {
    static getCartDetails(storeId, request, isSectionPreloader = false) {
        let url = ApiUrlConstant.getApiUrl('cartInfo');
        url = Util.beautifyUrl(url, [storeId]);
        
        if (isSectionPreloader) {
            return Api.doPost(url, request, true, {}, true, true);
        } else {
            return Api.doPost(url, request);
        }
    }
    static passTheBasket(storeId, request) {
        let url = ApiUrlConstant.getApiUrl('passTheBasket', true);
        url = Util.beautifyUrl(url, [storeId]);
        return Api.doPost(url, request, true, {}, false, false, false);
    }
    static dummyPassTheBasket(storeId, request) {
        var passTheBasketPromise = new Promise(function(resolve, reject) {
            let passTheBasket = {
                "passTheBasketStatus": "Success",
                "status": "Success",
                "needPassTheBasket": true,
                "message": "",
                "basketId": "50501162",
                "date": "2021-11-25T23:34:18-0500"
            }
            resolve(passTheBasket);
        });
    
        return passTheBasketPromise;
    }
    static getTaxDetail(storeId, request) {
        let url = ApiUrlConstant.getApiUrl('tax', true);
        url = Util.beautifyUrl(url, [storeId]);
        return Api.doPost(url, request);
    }
    static getDummyTaxDetail(storeId, request) {
        var taxPromise = new Promise(function(resolve, reject) {
            let tax = request.subTotal*0.07;
            let taxOnMfsrp = request.msfrpTotal*0.07;
            let taxDetails = {
                "status": "success",
                "taxDetail": {
                    "subTotal": request.subTotal,
                    "estimatedTax": tax,
                    "total": request.subTotal+tax,
                    "products": [],
                    "customer": {},
                    "msfrpTotal": request.msfrpTotal,
                    "taxOnMfsrp": request.taxOnMfsrp,
                    "totalOnMfsrp": request.msfrpTotal+request.taxOnMfsrp
                }
            }
            resolve(taxDetails);
        });
    
        return taxPromise;
    }
}